import '../../css/sidebar_header.css';
import Header from '../Header/Header';
import ViewPatientAppointments from './ViewPatientAppointmentsComponent';

export default function PatientAppointmentsPage() {
    return (
        <div className="min-h-screen bg-[#edeef2]">
            <Header />
            <main className="pt-[30px] mx-4">
                <div className="flex items-center justify-between py-4 px-4 sm:px-6">
                    <h1 className="text-base sm:text-xl font-bold text-gray-800">Appointments</h1>
                </div>
                <div className="bg-white rounded-xl overflow-hidden mx-2 sm:mx-6 mb-6">
                    <ViewPatientAppointments />
                </div>
            </main>
        </div>
    );
}